const logger = (() => {
  const isLogEnabled = () => {
    const env = window.env.CONFIG_ENVIRONMENT; // Đảm bảo môi trường được định nghĩa trong Vite
    return env === "beta" || env === "staging";
  };

  const log = (...args: unknown[]) => {
    if (isLogEnabled()) {
      console.log(...args);
    }
  };

  const warn = (...args: unknown[]) => {
    if (isLogEnabled()) {
      console.warn(...args);
    }
  };

  const error = (...args: unknown[]) => {
    if (isLogEnabled()) {
      console.error(...args);
    }
  };

  return {
    log,
    warn,
    error,
  };
})();

export default logger;
